// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-info-text {
	color: var(--scouting-america-white);

	font-size: var(--body-normal-size);

	padding-left: 20px;
	padding-right: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.css"],"names":[],"mappings":"AAAA;CACC,oCAAoC;;CAEpC,kCAAkC;;CAElC,kBAAkB;CAClB,mBAAmB;AACpB","sourcesContent":[".login-info-text {\n\tcolor: var(--scouting-america-white);\n\n\tfont-size: var(--body-normal-size);\n\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
